import { combine } from 'effector';
import { accountTreeModel } from 'entities/account';
import { createPlayerRegistryModel } from 'entities/player';
import { accountPageModel } from './account-page-model';

const $filterAccountIds = combine(
	accountPageModel.$accountId,
	accountTreeModel.$nodes,
	(accountId, nodes) => {
		if (accountId === null) return [];

		const accountIds = Object.values(nodes)
			.filter((node) => node.value.parents.split('.').includes(String(accountId)))
			.map((node) => node.id);

		return accountIds.length > 0 ? accountIds : [accountId];
	},
);

const playerRegistryModel = createPlayerRegistryModel({
	$accountId: accountPageModel.$accountId,
	$allAccountIds: $filterAccountIds,
	$currencies: accountTreeModel.$currencies,
	onUpdate: [accountPageModel.accountIdSet],
});

export const accountPagePlayersModel = {
	playerRegistryModel,
};
